export var ThemedEventConstants;
(function (ThemedEventConstants) {
    ThemedEventConstants[ThemedEventConstants["eventTotalEpisodes"] = 6] = "eventTotalEpisodes";
})(ThemedEventConstants || (ThemedEventConstants = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/ThemedEventConstants.ts
// module id = 388
// module chunks = 3